/* assets/pomo-delivery.js */
(() => {
  if (window.__POMO_DELIVERY_INIT__) return;
  window.__POMO_DELIVERY_INIT__ = true;

  const SELECTOR_DESKTOP_SLOT = ".minicart__delivery-widget-slot";
  const SELECTOR_MINICART_BODY =
    ".minicart-body, #minicart-form .minicart-body, #minicart-form .items";
  const SELECTOR_MINICART_OPEN_STATE =
    ".bls__drawer.open, .popup_cart.open, html.open-minicart, body.open-minicart, .minicart__wrapper.open";

  const MOBILE_NAV_SELECTOR =
    "mobile-navigation-bar.mobile-navigation-bar, mobile-navigation-bar, .mobile-navigation-bar";

  const MOBILE_HOST_ID = "pomo-delivery-mobile-host";
  const STORAGE_POSTCODE_KEY = "pomo_delivery_postcode";

  // Header postcode slot (must exist in header liquid)
  const HEADER_SLOT_ID = "pomo-header-postcode-slot";

  // ✅ Cart page host
  const CART_PAGE_HOST_ID = "pomo-delivery-cart-host";
  const CART_PAGE_INSERT_SELECTORS = ["#main-cart-items", ".cart-wrapper", "main"];

  // ✅ Top sheet (postcode gate)
  const POSTCODE_SHEET_ID = "pomo-postcode-sheet";
  const POSTCODE_SHEET_STYLE_ID = "pomo-postcode-sheet-style";

  let headerPostcodeEnabled = false;

  // ✅ gate bypass flag (so we can re-trigger the original add-to-cart after saving postcode)
  let __pomoSkipGateOnce = false;

  const debounce = (fn, ms = 150) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  };

  const isMobile = () => window.matchMedia("(max-width: 1024.98px)").matches;

  // ✅ FIX: strict cart-page detection (supports /cart and /fr/cart)
  function isCartPage() {
    try {
      const p = String(location.pathname || "").replace(/\/+$/, "");
      const segs = p.split("/").filter(Boolean);
      const last = (segs[segs.length - 1] || "").toLowerCase();
      if (last === "cart") return true;
    } catch (_) {}

    // fallback: only cart-page markers (exclude cart forms in header)
    const body = document.body;
    if (body) {
      if (
        body.classList.contains("cart") ||
        body.classList.contains("template-cart") ||
        body.classList.contains("template-cart-ajax")
      ) {
        return true;
      }
    }

    return !!document.querySelector(
      [
        "#main-cart-items",
        "cart-items",
        "main-cart-items",
        "[data-template='cart']",
      ].join(",")
    );
  }

  function isMinicartOpen() {
    const wrapper = document.querySelector("#header__minicart .minicart__wrapper");
    if (!wrapper) return false;
    if (!document.documentElement.classList.contains("open-minicart")) return false;
    return wrapper.classList.contains("open");
  }

  // ---------- i18n ----------
  const I18N = {
    en: {
      label_postcode: "Postcode",
      btn_ok: "OK",

      hint_enter: "Enter your postcode to see delivery.",
      hint_unavailable: "Delivery not available for this postcode.",
      hint_no_tiers: "Delivery rates unavailable.",

      // delivery messaging
      msg_min_spend: (amount) => `Add ${amount} to reach minimum spend`,
      msg_delivery_reduce: (curDelivery, addAmount, nextDelivery) =>
        `Delivery ${curDelivery} - add ${addAmount} to reduce delivery to ${nextDelivery}`,
      msg_delivery_free: (curDelivery, addAmount) =>
        `Delivery ${curDelivery} - add ${addAmount} for free delivery`,
      msg_free_delivery: "Free delivery",
      msg_updated: "Updated.",

      // sheet
      sheet_title: "To continue shopping, enter your delivery postcode",
      sheet_placeholder: "e.g. 75001",
      sheet_cta: "Save",
      sheet_unavailable:
        "Your postcode is outside our delivery area. Please contact support to learn more.",
      sheet_close_aria: "Close",
    },

    fr: {
      label_postcode: "Code postal",
      btn_ok: "OK",

      hint_enter: "Entrez votre code postal pour voir la livraison.",
      hint_unavailable: "Zone de livraison non disponible pour ce code postal.",
      hint_no_tiers: "Tarifs de livraison indisponibles.",

      // delivery messaging
      msg_min_spend: (amount) =>
        `Ajoutez ${amount} pour atteindre le montant minimum de dépenses`,
      msg_delivery_reduce: (curDelivery, addAmount, nextDelivery) =>
        `Livraison ${curDelivery} - ajoutez ${addAmount} pour réduire les frais de livraison à ${nextDelivery}`,
      msg_delivery_free: (curDelivery, addAmount) =>
        `Livraison ${curDelivery} - ajoutez ${addAmount} pour une livraison gratuite`,
      msg_free_delivery: "Livraison gratuite",
      msg_updated: "Mise à jour.",

      // sheet
      sheet_title:
        "Pour continuer vos achats, saisissez votre code postal de livraison",
      sheet_placeholder: "ex. 75001",
      sheet_cta: "Enregistrer",
      sheet_unavailable:
        "Votre code postal n’est pas dans notre zone de livraison. Merci de contacter le support pour plus de détails.",
      sheet_close_aria: "Fermer",
    },

    ru: {
      label_postcode: "Индекс",
      btn_ok: "OK",

      hint_enter: "Введите индекс, чтобы увидеть доставку.",
      hint_unavailable: "Доставка недоступна для этого индекса.",
      hint_no_tiers: "Тарифы доставки недоступны.",

      // delivery messaging
      msg_min_spend: (amount) =>
        `Добавьте ${amount} для достижения минимальной суммы покупки`,
      msg_delivery_reduce: (curDelivery, addAmount, nextDelivery) =>
        `Доставка ${curDelivery} - добавьте ${addAmount}, чтобы уменьшить доставку до ${nextDelivery}`,
      msg_delivery_free: (curDelivery, addAmount) =>
        `Доставка ${curDelivery} - добавьте ${addAmount} до бесплатной доставки`,
      msg_free_delivery: "Бесплатная доставка",
      msg_updated: "Обновлено.",

      // sheet
      sheet_title: "Для продолжения покупок введите ваш индекс доставки",
      sheet_placeholder: "например 75001",
      sheet_cta: "Сохранить",
      sheet_unavailable:
        "Ваш индекс не входит в нашу зону доставки, пожалуйста напишите в поддержку, чтобы узнать детали",
      sheet_close_aria: "Закрыть",
    },
  };

  function getLang() {
    const l =
      document.documentElement.getAttribute("lang") ||
      (window.Shopify && Shopify.locale) ||
      "en";
    const base = String(l).toLowerCase().split("-")[0];
    return I18N[base] ? base : "en";
  }

  function t(key, ...args) {
    const lang = getLang();
    const entry = I18N[lang][key] ?? I18N.en[key];
    return typeof entry === "function" ? entry(...args) : entry;
  }

  function getLocaleForIntl() {
    const lang = getLang();
    if (lang === "fr") return "fr-FR";
    if (lang === "ru") return "ru-RU";
    return "en-US";
  }

  // ---------- Zones JSON ----------
  function readZonesJSON() {
    const el = document.getElementById("pomo-delivery-zones");
    if (!el) return { zones: [] };
    try {
      return JSON.parse(el.textContent || el.innerText || "{}");
    } catch (e) {
      console.warn("[POMO] Zones JSON parse failed", e);
      return { zones: [] };
    }
  }

  function normalizePostcode(v) {
    return String(v || "").trim();
  }

  function findZoneByPostcode(zones, postcode) {
    const pc = normalizePostcode(postcode);
    if (!pc) return null;
    for (const z of zones || []) {
      const list = Array.isArray(z.postal_codes) ? z.postal_codes : [];
      if (list.some((x) => normalizePostcode(x) === pc)) return z;
    }
    return null;
  }

  // ✅ validator used by the sheet
  function isPostcodeInDeliveryZones(pc) {
    const norm = normalizePostcode(pc);
    if (!norm) return false;

    const zonesData = readZonesJSON();
    const zones = zonesData && zonesData.zones ? zonesData.zones : [];
    const zone = findZoneByPostcode(zones, norm);
    return !!zone;
  }

  function safeParseTiers(tiersField) {
    if (Array.isArray(tiersField)) return tiersField;
    if (tiersField == null) return [];
    if (typeof tiersField === "string") {
      const s = tiersField.trim();
      if (!s) return [];
      try {
        const parsed = JSON.parse(s);
        if (Array.isArray(parsed)) return parsed;
      } catch (_) {
        try {
          const repaired = s
            .replace(/"\s*price"\s*:/g, ',"price":')
            .replace(/(\d)\s*"price"\s*:/g, '$1,"price":');
          const parsed2 = JSON.parse(repaired);
          if (Array.isArray(parsed2)) return parsed2;
        } catch (e2) {
          console.warn("[POMO] tiers parse failed", e2, s);
        }
      }
    }
    return [];
  }

  function sortTiers(tiers) {
    return (tiers || [])
      .map((tt) => ({
        from: tt && tt.from != null ? Number(tt.from) : 0,
        to: tt && tt.to != null ? Number(tt.to) : null,
        price: tt && tt.price != null ? Number(tt.price) : 0,
      }))
      .filter((x) => Number.isFinite(x.from))
      .sort((a, b) => a.from - b.from);
  }

  // ---------- Money ----------
  function moneyFromCents(cents, currency = "EUR") {
    const v = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(getLocaleForIntl(), {
        style: "currency",
        currency,
      }).format(v);
    } catch {
      return `${v.toFixed(2)}€`;
    }
  }

  function moneyFromEuros(euros, currency = "EUR") {
    const cents = Math.round(Number(euros || 0) * 100);
    return moneyFromCents(cents, currency);
  }

  const clamp01 = (x) => Math.max(0, Math.min(1, x));

  // ---------- Progress (segmented) ----------
  function calcProgressSegmented(cartTotal, tiersSorted) {
    const tiers = tiersSorted || [];
    const n = tiers.length;
    if (!n) return { progress01: 0, nextThreshold: null, thresholdLabel: null };

    const total = Math.max(0, Number(cartTotal || 0));

    const raw = tiers
      .map((x) => Number(x && x.from != null ? x.from : 0))
      .filter((v) => Number.isFinite(v) && v > 0)
      .sort((a, b) => a - b);

    const boundaries = [0];
    for (const v of raw) {
      if (v > boundaries[boundaries.length - 1]) boundaries.push(v);
    }

    if (boundaries.length < 2) {
      return {
        progress01: total > 0 ? 1 : 0,
        nextThreshold: null,
        thresholdLabel: null,
      };
    }

    const segments = boundaries.length - 1;
    const lastBoundary = boundaries[boundaries.length - 1];

    if (total >= lastBoundary) {
      return { progress01: 1, nextThreshold: null, thresholdLabel: null };
    }

    for (let i = 0; i < segments; i++) {
      const a = boundaries[i];
      const b = boundaries[i + 1];
      const segStart = i / segments;

      if (total < a) {
        return {
          progress01: clamp01(segStart),
          nextThreshold: a,
          thresholdLabel: `${a}€`,
        };
      }

      if (total >= a && total < b) {
        const denom = b - a > 0 ? b - a : 1;
        const within = (total - a) / denom;
        const progress = segStart + within * (1 / segments);

        return {
          progress01: clamp01(progress),
          nextThreshold: b,
          thresholdLabel: `${b}€`,
        };
      }
    }

    return { progress01: 1, nextThreshold: null, thresholdLabel: null };
  }

  // ---------- Tier helpers ----------
  function findCurrentTierIndex(totalEuros, tiersSorted) {
    const tiers = tiersSorted || [];
    if (!tiers.length) return -1;

    const total = Number(totalEuros || 0);

    for (let i = 0; i < tiers.length; i++) {
      const tier = tiers[i];
      const from = Number(tier.from || 0);
      const to = tier.to == null ? null : Number(tier.to);

      const fromOk = total >= from;
      const toOk = to == null ? true : total <= to;

      if (fromOk && toOk) return i;
    }

    return tiers.length - 1;
  }

  function findMinSpend(tiersSorted) {
    const tiers = tiersSorted || [];
    const mins = tiers
      .map((x) => Number(x.from || 0))
      .filter((v) => Number.isFinite(v) && v > 0)
      .sort((a, b) => a - b);
    return mins.length ? mins[0] : 0;
  }

  // ---------- Cart ----------
  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js failed");
    return await res.json();
  }

  function installCartHook(onCartChanged) {
    const trigger = debounce(onCartChanged, 120);

    const origFetch = window.fetch;
    window.fetch = async function (...args) {
      const r = await origFetch.apply(this, args);
      try {
        const url =
          typeof args[0] === "string"
            ? args[0]
            : (args[0] && args[0].url) || "";
        if (url.includes("/cart/")) setTimeout(trigger, 80);
      } catch (_) {}
      return r;
    };

    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__pomo_url__ = url;
      return origOpen.call(this, method, url, ...rest);
    };
    const origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (...args) {
      this.addEventListener("loadend", () => {
        try {
          const url = this.__pomo_url__ || "";
          if (String(url).includes("/cart/")) setTimeout(trigger, 80);
        } catch (_) {}
      });
      return origSend.apply(this, args);
    };

    document.addEventListener("cart:updated", trigger);
    document.addEventListener("cart:refresh", trigger);

    document.addEventListener("click", (e) => {
      const a =
        e.target &&
        e.target.closest &&
        e.target.closest("#cart-icon-bubble, #cart-icon-bubble-mobile");
      if (a) setTimeout(trigger, 180);
    });
  }

  // ---------- Shared postcode setter ----------
  function setPostcodeEverywhere(pc) {
    const norm = normalizePostcode(pc);
    localStorage.setItem(STORAGE_POSTCODE_KEY, norm);

    const headerInput = document.querySelector(
      `#${HEADER_SLOT_ID} .pomo-header-postcode__input`
    );
    if (headerInput) headerInput.value = norm;

    for (const inst of instances.values()) inst.setPostcode(norm);
    document.dispatchEvent(new CustomEvent("pomo:postcode:changed"));
  }
  window.POMO_DELIVERY = window.POMO_DELIVERY || {};
  window.POMO_DELIVERY.setPostcode = setPostcodeEverywhere;

  // ---------- Header postcode UI ----------
  function ensureHeaderPostcodeUI() {
    const slot = document.getElementById(HEADER_SLOT_ID);
    headerPostcodeEnabled = !!slot;
    if (!slot) return null;

    const existingInput = slot.querySelector(".pomo-header-postcode__input");
    if (existingInput) {
      existingInput.setAttribute("placeholder", "75001");
      existingInput.setAttribute("aria-label", t("label_postcode"));
      return slot;
    }

    slot.innerHTML = "";
    slot.classList.add("pomo-header-postcode-slot");

    const wrap = document.createElement("div");
    wrap.className = "pomo-header-postcode";

    const icon = document.createElement("span");
    icon.className = "pomo-header-postcode__icon";
    icon.setAttribute("aria-hidden", "true");
    icon.innerHTML = `
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.6"/>
        <path d="M12 6.8c-2 0-3.6 1.6-3.6 3.6 0 2.6 3.6 6.8 3.6 6.8s3.6-4.2 3.6-6.8c0-2-1.6-3.6-3.6-3.6Z"
              stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
        <circle cx="12" cy="10.4" r="1.1" fill="currentColor"/>
      </svg>
    `;

    const input = document.createElement("input");
    input.className = "pomo-header-postcode__input";
    input.inputMode = "numeric";
    input.autocomplete = "postal-code";
    input.placeholder = "75001";
    input.setAttribute("aria-label", t("label_postcode"));

    const saved = normalizePostcode(localStorage.getItem(STORAGE_POSTCODE_KEY) || "");
    if (saved) input.value = saved;

    const apply = () => {
      const pc = normalizePostcode(input.value);
      localStorage.setItem(STORAGE_POSTCODE_KEY, pc);
      for (const inst of instances.values()) inst.setPostcode(pc);
      document.dispatchEvent(new CustomEvent("pomo:postcode:changed"));
      hidePostcodeSheet();
    };

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        apply();
        input.blur();
      }
    });
    input.addEventListener("blur", apply);

    wrap.appendChild(icon);
    wrap.appendChild(input);
    slot.appendChild(wrap);

    return slot;
  }

  // ---------- Mobile host ----------
  function ensureMobileHost() {
    let host = document.getElementById(MOBILE_HOST_ID);
    const nav = document.querySelector(MOBILE_NAV_SELECTOR);
    if (!nav) return null;

    if (!host) {
      host = document.createElement("div");
      host.id = MOBILE_HOST_ID;
      host.setAttribute("data-pomo-host", "mobile");
      host.style.display = "none";
      document.body.appendChild(host);
    }

    const place = () => {
      const rect = nav.getBoundingClientRect();
      const navH = rect.height || 60;

      host.style.position = "fixed";
      host.style.left = "0";
      host.style.right = "0";
      host.style.bottom = `${navH}px`;
      host.style.zIndex = "99999";
      host.style.pointerEvents = "auto";
    };

    place();
    window.addEventListener("resize", debounce(place, 100));
    window.addEventListener("orientationchange", debounce(place, 100));

    return host;
  }

  // ✅ Cart page host (auto insert at top of cart)
  function ensureCartPageHost() {
    if (!isCartPage()) return null;

    let host = document.getElementById(CART_PAGE_HOST_ID);
    if (host && host.isConnected) return host;

    let container = null;
    for (const sel of CART_PAGE_INSERT_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) {
        container = el;
        break;
      }
    }
    if (!container) return null;

    host = document.createElement("div");
    host.id = CART_PAGE_HOST_ID;
    host.setAttribute("data-pomo-host", "cart");
    host.style.marginBottom = "12px";

    container.prepend(host);
    return host;
  }

  // ---------- Desktop slot fallback ----------
  function ensureDesktopSlot() {
    const existing = document.querySelector(SELECTOR_DESKTOP_SLOT);
    if (existing) return existing;

    document.querySelector(SELECTOR_MINICART_OPEN_STATE);
    const body = document.querySelector(SELECTOR_MINICART_BODY);
    if (!body) return null;

    const slot = document.createElement("div");
    slot.className = "minicart__delivery-widget-slot pomo-delivery--compact";
    slot.style.marginBottom = "12px";

    const items = body.querySelector(".items");
    if (items && items.parentNode) {
      items.parentNode.insertBefore(slot, items);
      return slot;
    }
    body.prepend(slot);
    return slot;
  }

  // ---------- Instances ----------
  const instances = new Map(); // mountEl -> instance
  let lastCart = null;

  function pruneDeadInstances() {
    for (const [el] of instances.entries()) {
      if (!el || !el.isConnected) instances.delete(el);
    }
  }

  function cleanupDuplicates() {
    const desktopSlots = new Set(Array.from(document.querySelectorAll(SELECTOR_DESKTOP_SLOT)));
    const mobileHost = document.getElementById(MOBILE_HOST_ID);
    const cartHost = document.getElementById(CART_PAGE_HOST_ID);

    document.querySelectorAll(".pomo-delivery").forEach((node) => {
      const slot = node.closest(SELECTOR_DESKTOP_SLOT);
      const inDesktop = slot && desktopSlots.has(slot);
      const inMobile = mobileHost ? mobileHost.contains(node) : false;
      const inCart = cartHost ? cartHost.contains(node) : false;

      if (!inDesktop && !inMobile && !inCart) node.remove();
    });

    desktopSlots.forEach((slot) => {
      const widgets = slot.querySelectorAll(".pomo-delivery");
      widgets.forEach((w, idx) => idx > 0 && w.remove());
    });

    if (mobileHost) {
      const widgets = mobileHost.querySelectorAll(".pomo-delivery");
      widgets.forEach((w, idx) => idx > 0 && w.remove());
    }

    if (cartHost) {
      const widgets = cartHost.querySelectorAll(".pomo-delivery");
      widgets.forEach((w, idx) => idx > 0 && w.remove());
    }
  }

  // ---------- Widget ----------
  class PomoWidget {
    constructor(mountEl, mode) {
      this.mountEl = mountEl;
      this.mode = mode; // 'desktop' | 'mobile' | 'cart'

      this.zonesData = readZonesJSON();
      this.currency =
        window.Shopify && Shopify.currency && Shopify.currency.active
          ? Shopify.currency.active
          : "EUR";

      this.state = {
        postcode: normalizePostcode(localStorage.getItem(STORAGE_POSTCODE_KEY) || ""),
        zone: null,
        tiers: [],
        cart: null,
      };

      this.render();
    }

    ensureAlive() {
      if (!this.root || !this.root.isConnected || !this.mountEl.contains(this.root)) {
        this.render();
        if (lastCart) this.setCart(lastCart);
      }
    }

    setPostcode(pc) {
      this.ensureAlive();
      const norm = normalizePostcode(pc);
      this.state.postcode = norm;
      if (this.input) this.input.value = norm;

      this.resolveZone();
      this.buildSegments();
      this.updateUI();

      if (norm) hidePostcodeSheet();
    }

    applyLanguage() {
      this.ensureAlive();
      if (this.label) this.label.textContent = t("label_postcode");
      if (this.btn) this.btn.textContent = t("btn_ok");
      this.updateUI();
    }

    render() {
      this.mountEl.innerHTML = "";

      const root = document.createElement("div");
      root.className = `pomo-delivery ${
        this.mode === "mobile"
          ? "pomo-delivery--mobile"
          : this.mode === "cart"
          ? "pomo-delivery--cart"
          : "pomo-delivery--compact"
      }`;

      const showPostcodeUIInsideWidget = !headerPostcodeEnabled;

      root.innerHTML = `
        ${
          showPostcodeUIInsideWidget
            ? `
          <label class="pomo-delivery__label"></label>
          <div class="pomo-delivery__zip-row">
            <input class="pomo-delivery__input" inputmode="numeric" autocomplete="postal-code" placeholder="75001" />
            <button class="pomo-delivery__btn" type="button"></button>
          </div>
        `
            : ``
        }

        <div class="pomo-delivery__progress">
          <div class="pomo-delivery__track">
            <div class="pomo-delivery__fill" style="width:0%"></div>
            <div class="pomo-progress__segments" aria-hidden="true"></div>
          </div>
          <div class="pomo-delivery__steps" aria-hidden="true"></div>
          <div class="pomo-delivery__status"></div>
        </div>
      `;

      this.root = root;

      this.label = root.querySelector(".pomo-delivery__label");
      this.input = root.querySelector(".pomo-delivery__input");
      this.btn = root.querySelector(".pomo-delivery__btn");

      this.fill = root.querySelector(".pomo-delivery__fill");
      this.segments = root.querySelector(".pomo-progress__segments");
      this.steps = root.querySelector(".pomo-delivery__steps");
      this.status = root.querySelector(".pomo-delivery__status");
      if (this.status) this.status.style.fontWeight = "700";

      this.mountEl.appendChild(root);

      if (this.input && this.state.postcode) this.input.value = this.state.postcode;

      if (this.btn && this.input) {
        this.btn.addEventListener("click", () => this.applyPostcodeFromWidget());
        this.input.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            this.applyPostcodeFromWidget();
          }
        });
      }

      this.resolveZone();
      this.buildSegments();
      this.applyLanguage();
      this.updateUI();
    }

    applyPostcodeFromWidget() {
      if (!this.input) return;
      const pc = normalizePostcode(this.input.value);
      setPostcodeEverywhere(pc);
      hidePostcodeSheet();
    }

    resolveZone() {
      const zones = this.zonesData && this.zonesData.zones ? this.zonesData.zones : [];
      const zone = findZoneByPostcode(zones, this.state.postcode);
      this.state.zone = zone;

      const tiersRaw = zone ? safeParseTiers(zone.tiers) : [];
      this.state.tiers = sortTiers(tiersRaw);
    }

    buildSegments() {
      const tiers = this.state.tiers || [];
      const n = tiers.length;

      this.segments.innerHTML = "";
      this.steps.innerHTML = "";
      if (!n) return;

      for (let i = 0; i < n; i++) {
        const seg = document.createElement("div");
        seg.className = "pomo-progress__seg";
        this.segments.appendChild(seg);
      }

      for (let i = 0; i < n; i++) {
        const boundaryValue = Number(tiers[i]?.from ?? 0);
        if (!Number.isFinite(boundaryValue) || boundaryValue <= 0) continue;

        const s = document.createElement("span");
        s.textContent = `€${boundaryValue}`;

        const leftPct = ((i + 1) / n) * 100;
        s.style.left = `${leftPct}%`;

        if (i === n - 1) s.classList.add("pomo-step--end");
        this.steps.appendChild(s);
      }
    }

    setCart(cart) {
      this.ensureAlive();
      this.state.cart = cart;
      this.updateUI();
    }

    updateUI() {
      this.ensureAlive();

      const { zone, tiers, cart } = this.state;

      if (!cart || typeof cart.item_count !== "number" || cart.item_count === 0) {
        this.root.setAttribute("hidden", "hidden");
        if (this.mode === "mobile") {
          const host = document.getElementById(MOBILE_HOST_ID);
          if (host) host.style.display = "none";
        }
        return;
      }

      this.root.removeAttribute("hidden");
      if (this.mode === "mobile") {
        const host = document.getElementById(MOBILE_HOST_ID);
        if (host) host.style.display = "";
      }

      if (!zone) {
        this.status.textContent = this.state.postcode ? t("hint_unavailable") : t("hint_enter");
        this.fill.style.width = "0%";
        return;
      }

      if (!tiers || !tiers.length) {
        this.status.textContent = t("hint_no_tiers");
        this.fill.style.width = "0%";
        return;
      }

      const cents =
        typeof cart.items_subtotal_price === "number" && cart.items_subtotal_price >= 0
          ? cart.items_subtotal_price
          : typeof cart.total_price === "number"
          ? cart.total_price
          : 0;

      const basketValue = cents / 100;

      const { progress01 } = calcProgressSegmented(basketValue, tiers);
      const pct = Math.round(progress01 * 1000) / 10;
      this.fill.style.width = `${pct}%`;

      const minSpend = findMinSpend(tiers);

      if (minSpend > 0 && basketValue < minSpend) {
        const diff = Math.max(0, minSpend - basketValue);
        const addAmount = moneyFromEuros(diff, this.currency);
        this.status.textContent = t("msg_min_spend", addAmount);
        return;
      }

      const curIdx = findCurrentTierIndex(basketValue, tiers);
      const curTier = curIdx >= 0 ? tiers[curIdx] : null;

      if (!curTier) {
        this.status.textContent = t("msg_updated");
        return;
      }

      const curDelivery = moneyFromEuros(curTier.price, this.currency);
      const nextTier = tiers[curIdx + 1] || null;

      if (!nextTier) {
        this.status.textContent = Number(curTier.price) === 0 ? t("msg_free_delivery") : t("msg_updated");
        return;
      }

      const nextThreshold = Number(nextTier.from || 0);
      const diff = Math.max(0, nextThreshold - basketValue);
      const addAmount = moneyFromEuros(diff, this.currency);

      if (Number(nextTier.price) === 0) {
        this.status.textContent = t("msg_delivery_free", curDelivery, addAmount);
        return;
      }

      const nextDelivery = moneyFromEuros(nextTier.price, this.currency);
      this.status.textContent = t("msg_delivery_reduce", curDelivery, addAmount, nextDelivery);
    }
  }

  // ---------- Mount logic ----------
  function mountDesktop() {
    const slot = document.querySelector(SELECTOR_DESKTOP_SLOT) || ensureDesktopSlot();
    if (!slot) return;

    const widgetMissing = !slot.querySelector(".pomo-delivery");
    if (!instances.has(slot) || widgetMissing) {
      instances.delete(slot);
      const inst = new PomoWidget(slot, "desktop");
      instances.set(slot, inst);
      if (lastCart) inst.setCart(lastCart);
    }
  }

  function mountMobile() {
    const host = ensureMobileHost();
    if (!host) return;

    const widgetMissing = !host.querySelector(".pomo-delivery");
    if (!instances.has(host) || widgetMissing) {
      instances.delete(host);
      const inst = new PomoWidget(host, "mobile");
      instances.set(host, inst);
      if (lastCart) inst.setCart(lastCart);
    }
  }

  function mountCartPage() {
    const host = ensureCartPageHost();
    if (!host) return;

    const widgetMissing = !host.querySelector(".pomo-delivery");
    if (!instances.has(host) || widgetMissing) {
      instances.delete(host);
      const inst = new PomoWidget(host, "cart");
      instances.set(host, inst);
      if (lastCart) inst.setCart(lastCart);
    }
  }

  function unmountDesktop() {
    for (const [el, inst] of instances.entries()) {
      if (inst.mode === "desktop") instances.delete(el);
    }
  }

  function unmountMobile() {
    const host = document.getElementById(MOBILE_HOST_ID);
    if (host && instances.has(host)) instances.delete(host);
  }

  function clearDesktopWidgets() {
    document.querySelectorAll(SELECTOR_DESKTOP_SLOT).forEach((slot) => {
      slot.querySelectorAll(".pomo-delivery").forEach((n) => n.remove());
    });
  }

  // ✅ IMPORTANT: in MOBILE on /cart there must be no cart-top widget
  function unmountCartPage() {
    const host = document.getElementById(CART_PAGE_HOST_ID);
    if (!host) return;

    if (instances.has(host)) instances.delete(host);
    host.querySelectorAll(".pomo-delivery").forEach((n) => n.remove());
    host.remove();
  }

  // ---------- Postcode gating: top sheet + overlay ----------
  let pendingAddToCart = null;

  function injectSheetStylesOnce() {
    if (document.getElementById(POSTCODE_SHEET_STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = POSTCODE_SHEET_STYLE_ID;
    style.textContent = `
      #${POSTCODE_SHEET_ID}[hidden]{ display:none !important; }
      #${POSTCODE_SHEET_ID}{ position: fixed; inset: 0; z-index: 100000; }
      #${POSTCODE_SHEET_ID} .pomo-sheet__overlay{ position:absolute; inset:0; background: rgba(0,0,0,.45); }
      #${POSTCODE_SHEET_ID} .pomo-sheet__panel{
        position:absolute; left:0; right:0; top:0;
        background:#fff; border-bottom: 1px solid rgba(0,0,0,.10);
        box-shadow: 0 10px 30px rgba(0,0,0,.12);
        padding: 14px 16px 16px;
      }
      #${POSTCODE_SHEET_ID} .pomo-sheet__toprow{
        display:flex; align-items:center; justify-content:space-between;
        gap:12px; margin-bottom: 10px;
      }
      #${POSTCODE_SHEET_ID} .pomo-sheet__title{
        font-weight: 800; font-size: 14px; line-height: 1.25; margin:0;
      }
      #${POSTCODE_SHEET_ID} .pomo-sheet__close{
        border:0; background: transparent; padding: 6px;
        cursor: pointer; line-height: 0; opacity: .8;
      }
      #${POSTCODE_SHEET_ID} .pomo-sheet__close:hover{ opacity: 1; }
      #${POSTCODE_SHEET_ID} .pomo-sheet__row{ display:flex; gap:10px; align-items:center; }
      #${POSTCODE_SHEET_ID} .pomo-sheet__input{
        flex:1; height: 42px; border: 1px solid rgba(0,0,0,.20);
        border-radius: 10px; padding: 0 12px; font-size: 14px;
        outline: none; background: #fff;
      }
      #${POSTCODE_SHEET_ID} .pomo-sheet__btn{
        height: 42px; padding: 0 14px; border: 0;
        border-radius: 10px; font-weight: 800; cursor: pointer;
      }
      #${POSTCODE_SHEET_ID} .pomo-sheet__error{
        margin-top: 8px; font-size: 12px; line-height: 1.25;
        color: #D0473E; font-weight: 700; display:none;
      }
      @media (min-width: 1025px){
        #${POSTCODE_SHEET_ID} .pomo-sheet__panel{
          left: 50%; transform: translateX(-50%); max-width: 560px;
          border-left: 1px solid rgba(0,0,0,.10);
          border-right: 1px solid rgba(0,0,0,.10);
          border-bottom-left-radius: 12px;
          border-bottom-right-radius: 12px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function getSheetEl() {
    return document.getElementById(POSTCODE_SHEET_ID);
  }

  function isPostcodeMissing() {
    const saved = normalizePostcode(localStorage.getItem(STORAGE_POSTCODE_KEY) || "");
    if (saved) return false;

    const headerInput = document.querySelector(
      `#${HEADER_SLOT_ID} .pomo-header-postcode__input`
    );
    const headerVal = headerInput ? normalizePostcode(headerInput.value) : "";
    return !headerVal;
  }

  function hidePostcodeSheet() {
    const el = getSheetEl();
    if (el) el.setAttribute("hidden", "hidden");
    pendingAddToCart = null;
  }

  function showPostcodeSheet(pending) {
    injectSheetStylesOnce();

    let el = getSheetEl();
    if (!el) {
      el = document.createElement("div");
      el.id = POSTCODE_SHEET_ID;
      el.setAttribute("hidden", "hidden");
      el.innerHTML = `
        <div class="pomo-sheet__overlay" data-pomo-sheet-close="1"></div>
        <div class="pomo-sheet__panel" role="dialog" aria-modal="true">
          <div class="pomo-sheet__toprow">
            <p class="pomo-sheet__title"></p>
            <button class="pomo-sheet__close" type="button" aria-label="">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>

          <div class="pomo-sheet__row">
            <input class="pomo-sheet__input" inputmode="numeric" autocomplete="postal-code" />
            <button class="pomo-sheet__btn" type="button"></button>
          </div>

          <div class="pomo-sheet__error"></div>
        </div>
      `;
      document.body.appendChild(el);

      const close = () => hidePostcodeSheet();
      el.querySelector(".pomo-sheet__close").addEventListener("click", close);
      el.querySelector("[data-pomo-sheet-close='1']").addEventListener("click", close);

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          const cur = getSheetEl();
          if (cur && !cur.hasAttribute("hidden")) close();
        }
      });

      const input = el.querySelector(".pomo-sheet__input");
      const btn = el.querySelector(".pomo-sheet__btn");
      const err = el.querySelector(".pomo-sheet__error");

      const showUnavailable = () => {
        err.textContent = t("sheet_unavailable");
        err.style.display = "block";
      };
      const clearUnavailable = () => {
        err.style.display = "none";
        err.textContent = "";
      };

      const validateOrShowError = () => {
        const pc = normalizePostcode(input.value);
        if (!pc) {
          clearUnavailable();
          return { ok: false, pc: "" };
        }
        const ok = isPostcodeInDeliveryZones(pc);
        if (!ok) showUnavailable();
        else clearUnavailable();
        return { ok, pc };
      };

      const apply = () => {
        const { ok, pc } = validateOrShowError();
        if (!pc) return;
        if (!ok) return;

        setPostcodeEverywhere(pc);
        hidePostcodeSheet();

        const act = pendingAddToCart;
        pendingAddToCart = null;

        __pomoSkipGateOnce = true;

        setTimeout(() => {
          try {
            if (act && act.submitter && typeof act.submitter.click === "function") {
              act.submitter.click();
              return;
            }
            if (act && act.el && typeof act.el.click === "function") {
              act.el.click();
              return;
            }
            if (act && act.form) {
              if (typeof act.form.requestSubmit === "function") {
                act.form.requestSubmit();
              } else {
                act.form.submit();
              }
            }
          } catch (_) {}
        }, 0);
      };

      btn.addEventListener("click", apply);
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          apply();
        }
      });

      input.addEventListener(
        "input",
        debounce(() => {
          validateOrShowError();
        }, 180)
      );

      input.addEventListener("blur", () => {
        validateOrShowError();
      });
    }

    el.querySelector(".pomo-sheet__title").textContent = t("sheet_title");
    el.querySelector(".pomo-sheet__input").setAttribute("placeholder", t("sheet_placeholder"));
    el.querySelector(".pomo-sheet__btn").textContent = t("sheet_cta");
    el.querySelector(".pomo-sheet__close").setAttribute("aria-label", t("sheet_close_aria"));

    const err = el.querySelector(".pomo-sheet__error");
    err.style.display = "none";
    err.textContent = "";

    const input = el.querySelector(".pomo-sheet__input");
    const headerInput = document.querySelector(
      `#${HEADER_SLOT_ID} .pomo-header-postcode__input`
    );
    input.value = headerInput ? normalizePostcode(headerInput.value) : "";
    setTimeout(() => input.focus(), 0);

    pendingAddToCart = pending || null;
    el.removeAttribute("hidden");
  }

  function isAddToCartClickTarget(target) {
    if (!target || !target.closest) return null;

    const btn = target.closest(
      [
        'button[name="add"]',
        'button[type="submit"][name="add"]',
        'button[type="submit"].product-form__submit',
        'button.product-form__submit',
        ".js-addtocart",
        ".js-addtocart-page",
        '[data-action="add-to-cart"]',
        "[data-add-to-cart]",
        'form[action^="/cart/add"] button[type="submit"]',
        'form[action*="/cart/add"] button[type="submit"]',
      ].join(",")
    );

    if (!btn) return null;

    const form = btn.closest('form[action^="/cart/add"], form[action*="/cart/add"]');
    return { btn, form };
  }

  function installAddToCartGate() {
    document.addEventListener(
      "click",
      (e) => {
        if (__pomoSkipGateOnce) {
          __pomoSkipGateOnce = false;
          return;
        }

        const sheet = getSheetEl();
        if (sheet && !sheet.hasAttribute("hidden")) return;

        const hit = isAddToCartClickTarget(e.target);
        if (!hit) return;

        if (!isPostcodeMissing()) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        if (hit.form) {
          showPostcodeSheet({ type: "form", form: hit.form, submitter: hit.btn });
        } else {
          showPostcodeSheet({ type: "click", el: hit.btn });
        }
      },
      true
    );
  }

  // ---------- Mount all ----------
  function mountAll() {
    pruneDeadInstances();
    cleanupDuplicates();

    ensureHeaderPostcodeUI();

    const onCartPage = isCartPage();
    const drawerOpen = isMinicartOpen();

    if (onCartPage) {
      if (isMobile()) unmountCartPage();
      else mountCartPage();
    } else {
      unmountCartPage();
    }

    if (isMobile()) {
      unmountDesktop();
      mountMobile();
    } else {
      unmountMobile();
      if (drawerOpen) {
        mountDesktop();
      } else {
        unmountDesktop();
        clearDesktopWidgets();
      }
    }
  }

  const refreshCartAndUpdate = debounce(async () => {
    try {
      const cart = await fetchCart();
      lastCart = cart;

      const host = document.getElementById(MOBILE_HOST_ID);
      if (host) host.style.display = cart.item_count > 0 ? "" : "none";

      for (const inst of instances.values()) inst.setCart(cart);
      cleanupDuplicates();

      if (isCartPage() && isMobile()) unmountCartPage();
    } catch (e) {
      console.warn("[POMO] cart refresh failed", e);
    }
  }, 120);

  function applyLanguageToInstances() {
    ensureHeaderPostcodeUI();
    for (const inst of instances.values()) inst.applyLanguage();

    const sheet = getSheetEl();
    if (sheet && !sheet.hasAttribute("hidden")) {
      sheet.querySelector(".pomo-sheet__title").textContent = t("sheet_title");
      sheet.querySelector(".pomo-sheet__input").setAttribute("placeholder", t("sheet_placeholder"));
      sheet.querySelector(".pomo-sheet__btn").textContent = t("sheet_cta");
      sheet.querySelector(".pomo-sheet__close").setAttribute("aria-label", t("sheet_close_aria"));

      const err = sheet.querySelector(".pomo-sheet__error");
      if (err && err.style.display !== "none") {
        err.textContent = t("sheet_unavailable");
      }
    }
  }

  function startObservers() {
    const onDomChange = debounce(() => {
      mountAll();
      refreshCartAndUpdate();
    }, 200);

    const mo = new MutationObserver(() => {
      onDomChange();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    const langObserver = new MutationObserver(() => {
      applyLanguageToInstances();
    });
    langObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["lang"],
    });

    window.addEventListener(
      "resize",
      debounce(() => {
        mountAll();
        refreshCartAndUpdate();
      }, 150)
    );
  }

  function init() {
    mountAll();
    refreshCartAndUpdate();

    installCartHook(() => {
      mountAll();
      refreshCartAndUpdate();
    });

    installAddToCartGate();
    startObservers();

    document.addEventListener("pomo:postcode:changed", () => {
      const saved = normalizePostcode(localStorage.getItem(STORAGE_POSTCODE_KEY) || "");
      if (saved) hidePostcodeSheet();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();